import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";

const Header = () => {
  const [open, setOpen] = useState(false);
  const [expended, setExpended] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const dropdownRef = useRef(null);

  return (
    <>
      <div className="xl:flex w-full justify-center h-24 bg-white fixed top-0 z-20 hidden shadow-it-blue-sh">
        <div className="theme-container w-full mx-auto">
          <header className="flex justify-between py-6 mx-auto items-center relative h-full w-full">
            <div className="flex gap-24 items-center">
              <Link to="/" aria-label="logo-home">
                <img
                  data-aos="fade"
                  src="assets/images/brand_logo.png"
                  alt=""
                  style={{ width: "200px" }}
                />
              </Link>
            </div>

            <div className="flex gap-7 items-center">
              <ul className="flex gap-10 text-main-black text-base leading-5 font-medium h-fit items-center">
                <li data-aos="fade">
                  <Link
                    className="home-two-nav-item no-underline text-black pb-[1px] leading-5 relative delay-200 hover:text-theme before:border-theme"
                    to="/"
                  >
                    Home
                  </Link>
                </li>
                <li data-aos="fade">
                  <Link
                    className="home-two-nav-item no-underline text-black pb-[1px] leading-5 relative delay-200 hover:text-theme before:border-theme"
                    to="/plans"
                  >
                    Plans
                  </Link>
                </li>
                <li data-aos="fade" className="group relative">
                  <a className="home-two-nav-item no-underline text-black pb-[1px] group leading-5 relative delay-200 hover:text-theme before:border-theme flex gap-2 items-center">
                    Terms &amp; Policies
                    <svg
                      className="transition-all duration-300 group-hover:rotate-180"
                      width={10}
                      height={10}
                      viewBox="0 0 19 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M2 2L9.5 8L17 2"
                        stroke="currentColor"
                        className="group-hover:stroke-[#F30A02] transition-all duration-300"
                        strokeWidth={3}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </a>
                  <div className="absolute px-2 -left-7 h-0 group-hover:h-[360px] overflow-hidden top-5 transition-all duration-700">
                    <ul className="max-h-fit min-w-[300px] bg-white mt-8 shadow-card-sm transition-all duration-300 overflow-hidden px-5 top-20 pb-4 rounded-b-md">
                      <li className="relative py-1">
                        <Link
                          className="home-two-nav-item no-underline leading-5 relative text-black hover:text-[#1D109E] w-fit before:border-theme"
                          to="/term-of-use"
                        >
                          Term Of Use
                        </Link>
                      </li>
                      <li className="relative py-1">
                        <Link
                          className="home-two-nav-item leading-5 relative text-black hover:text-[#1D109E] w-fit before:border-theme"
                          to="/shipping-delivery-policy"
                        >
                          Shipping &amp; Delivery Policy
                        </Link>
                      </li>
                      <li className="relative py-1">
                        <Link
                          className="home-two-nav-item leading-5 relative text-black hover:text-[#1D109E] w-fit before:border-theme"
                          to="/privacy-policy"
                        >
                          Privacy Policy
                        </Link>
                      </li>
                      <li className="relative py-1">
                        <Link
                          className="home-two-nav-item leading-5 relative text-black hover:text-[#1D109E] w-fit before:border-theme"
                          to="/cancellation-policy"
                        >
                          Cancellation Policy
                        </Link>
                      </li>
                    </ul>
                  </div>
                </li>
                <li data-aos="fade">
                  <Link
                    to="/contact"
                    className="home-two-nav-item text-black pb-[1px] leading-5 relative delay-200 hover:text-[#1D109E] before:border-theme"
                  >
                    Contact
                  </Link>
                </li>
              </ul>
              <a href="/login.html" target="_blank" className="">
                <div className="home-two-btn-bg py-2.5 group bg-mainBtn border-[#FF6501]">
                  <span className="text-base text-white group-hover:text-[#FF6501] transition-all duration-300 font-semibold relative z-10">
                    Login
                  </span>
                  <svg
                    className="relative z-10"
                    width={7}
                    height={12}
                    viewBox="0 0 7 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      className="group-hover:stroke-[#FF6501] transition-all duration-300"
                      d="M1.10254 10.5L4.89543 6.70711C5.22877 6.37377 5.39543 6.20711 5.39543 6C5.39543 5.79289 5.22877 5.62623 4.89543 5.29289L1.10254 1.5"
                      stroke="white"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </a>
            </div>
          </header>
        </div>
      </div>

      <header className="flex xl:hidden flex-col relative">
        <img
          src="assets/images/home-three/hero/header-shadow.svg"
          alt=""
          className="absolute bottom-10 z-30 anim-light-shadow"
        />
        <div className="h-16 bg-white flex items-center justify-between fixed top-0 left-0 z-50 w-full px-2.5">
          <a href="/">
            <img
              data-aos="fade"
              src="assets/images/brand_logo.png"
              alt="logo"
              style={{ width: "200px" }}
            />
          </a>
          <button
            aria-label="mobile-Menu"
            className="text-black text-48 w-6 h-6 toggle_nav_menu"
            id="mobile_nav_toggle_menu"
            onClick={toggleMenu}
          >
            {!isMenuOpen ? (
              <svg
                className="pointer-events-none transition-all duration-300 text-black"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512"
              >
                <path
                  fill="#000000"
                  d="M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"
                />
              </svg>
            ) : (
              <svg
                class="pointer-events-none transition-all duration-300"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 384 512"
              >
                <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"></path>
              </svg>
            )}
          </button>
        </div>
        <div className="transition-all duration-300">
          <div
            className={`fixed top-16 h-screen w-full overflow-y-scroll bg-white z-50 transition-all duration-300 ${
              isMenuOpen ? "left-0" : "-left-full"
            }`}
          >
            <div className="flex gap-28 flex-col pl-5 pt-5">
              <ul className="flex gap-5 flex-col text-black text-base leading-5 font-medium">
                <li>
                  <Link
                    className="home-two-nav-item no-underline text-black pb-[1px] leading-5 relative delay-200 hover:text-theme before:border-[#1D109E]"
                    to="/"
                  >
                    Home
                  </Link>
                </li>
                <li>
                  <Link
                    className="home-two-nav-item no-underline text-black pb-[1px] leading-5 relative delay-200 hover:text-theme before:border-[#1D109E]"
                    to="/plans"
                  >
                    Plans
                  </Link>
                </li>
                <li className="group relative">
                  <div className="home-two-nav-item no-underline text-black pb-[1px] leading-5 relative delay-200 hover:text-theme before:border-[#1D109E] flex gap-2 items-center">
                    Terms &amp; Policies
                    <svg
                      className="transition-all duration-300 group-hover:rotate-180"
                      width={10}
                      height={10}
                      viewBox="0 0 19 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M2 2L9.5 8L17 2"
                        stroke="currentColor"
                        strokeWidth={3}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <div className="px-2 -left-7 h-0 group-hover:h-[320px] overflow-hidden top-5 transition-all duration-700">
                    <ul className="max-h-fit min-w-[300px] bg-white mt-8 shadow-card-sm transition-all duration-300 overflow-hidden px-5 top-20 pb-4 rounded-b-md">
                      <li className="relative py-1">
                        <Link
                          className="home-two-nav-item no-underline leading-5 relative text-black hover:text-[#1D109E] w-fitbefore:border-[#1D109E]"
                          to="/term-of-use"
                        >
                          Term Of Use
                        </Link>
                      </li>
                      <li className="relative py-1">
                        <Link
                          className="home-two-nav-item leading-5 relative text-black hover:text-[#1D109E] w-fitbefore:border-[#1D109E]"
                          to="/shipping-delivery-policy"
                        >
                          Shipping &amp; Delivery Policy
                        </Link>
                      </li>
                      <li className="relative py-1">
                        <Link
                          className="home-two-nav-item leading-5 relative text-black hover:text-[#1D109E] w-fitbefore:border-[#1D109E]"
                          to="/privacy-policy"
                        >
                          Privacy Policy
                        </Link>
                      </li>
                      <li className="relative py-1">
                        <Link
                          className="home-two-nav-item leading-5 relative text-black hover:text-[#1D109E] w-fitbefore:border-[#1D109E]"
                          to="/cancellation-policy"
                        >
                          Cancellation Policy
                        </Link>
                      </li>
                    </ul>
                  </div>
                </li>
                <li>
                  <Link
                    to="/contact"
                    className="home-two-nav-item text-black pb-[1px] leading-5 relative delay-200 hover:text-[#1D109E] before:border-[#1D109E]"
                  >
                    Contact
                  </Link>
                </li>
              </ul>
            </div>
            <div className="flex gap-5 flex-col pl-5 mt-5">
              <a href="/login.html" target="_blank" className="">
                <div className="home-two-btn-bg py-2.5 group bg-mainBtn border-[#FF6501]">
                  <span className="text-base text-white group-hover:text-[#FF6501] transition-all duration-300 font-semibold relative z-10">
                    Login
                  </span>
                  <svg
                    className="relative z-10"
                    width={7}
                    height={12}
                    viewBox="0 0 7 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      className="group-hover:stroke-[#FF6501] transition-all duration-300"
                      d="M1.10254 10.5L4.89543 6.70711C5.22877 6.37377 5.39543 6.20711 5.39543 6C5.39543 5.79289 5.22877 5.62623 4.89543 5.29289L1.10254 1.5"
                      stroke="white"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </a>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
